import React from "react";
import {BlockMath} from "react-katex";
import HorizontalScroll from "./ui/HorizontalScroll";

export default function TaskSolutionSteps({steps}) {
  return <div className="task-solution-steps">{steps.map((step,index) => {
    const content=<>
      {step.description && <p>{step.description}</p>}
      {step.content}
      {step.math && <HorizontalScroll><BlockMath math={step.math}/></HorizontalScroll>}
    </>;
    return step.optional ? (
      <details key={index} style={{marginBottom:16}}>
        <summary style={{cursor:"pointer"}}>{step.title}</summary>
        {content}
      </details>
    ) : (
      <div key={index} style={{marginBottom:16}}>
        <p><strong>Krok {index+1}:</strong> {step.title}</p>
        {content}
      </div>
    );
  })}</div>;
}
